import Vue from 'vue'
import Router from 'vue-router'
import {main} from './mod/main.route'
import {auth} from './mod/auth.route'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/contact/',
  routes: [
    ...auth,
    ...main,
    {path: '*', redirect: '/login'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js